export default __webpack_public_path__ + "static/media/inr-symb.d94e382a.png";